import { Suspense } from 'react'
import { Outlet, useRouterState } from '@tanstack/react-router'
import { AppLoadingBar } from '@/shared/ui/app-loading-bar'
import { NavigationSidebar } from '@/shared/ui/navigation-sidebar'
import { PUBLIC_ROUTES } from '@/shared/ui/navigation-sidebar/nav-items'

export function RootLayout() {
  const isPublicRoute = useRouterState({
    select: state => PUBLIC_ROUTES.has(state.location.pathname),
  })

  const content = (
    <main className="flex min-h-svh min-w-0 flex-1 flex-col bg-[color:var(--color-dashboard-bg,#f5f5f5)]">
      <AppLoadingBar />
      <Suspense
        fallback={<div className="min-h-svh flex-1" aria-hidden="true" />}
      >
        <Outlet />
      </Suspense>
    </main>
  )

  if (isPublicRoute) {
    return content
  }

  return (
    <div className="flex min-h-svh w-full">
      <NavigationSidebar />
      {content}
    </div>
  )
}
